import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputCopySC } from './input.styled';
import { copyToClipboard } from '../../../utils/helpers';
import Button from '../button';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

const InputCopy = (props) => {
  const [copied, setCopied] = useState(false);
  const label = copied ? 'global_copy_done' : 'global_copy';

  const onCopy = () => {
    copyToClipboard(props.value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className={props.className}>
      <InputCopySC>
        <input type="text" value={props.value} readOnly />
        <Button type="PRIMARY" onClick={onCopy}>
          <FormattedMessage id={label} defaultMessage={dlt[`${label}`]} />
        </Button>
      </InputCopySC>
    </div>
  );
};

InputCopy.defaultProps = {
  className: '',
};

InputCopy.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
};

export { InputCopy };
